import { render, staticRenderFns } from "./AdminQuestion_answers_2.vue?vue&type=template&id=f0ea2a62&"
import script from "./AdminQuestion_answers_2.vue?vue&type=script&lang=js&"
export * from "./AdminQuestion_answers_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports